var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermostat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.788,
    height: 26.5,
    viewBox: "0 0 15.788 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1 {\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        fill: #7d7d7d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11286",
    "data-name": "Group 11286",
    transform: "translate(-161.25 -98.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7045",
    "data-name": "Path 7045",
    className: "cls-1",
    d: "M9.149,13.358h0a2.858,2.858,0,0,0-5.717,0V24.764h0a5.735,5.735,0,1,0,5.717.05",
    transform: "translate(161.5 88.5)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1084",
    "data-name": "Line 1084",
    className: "cls-2",
    x2: 5.717,
    transform: "translate(170.571 103.531)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1085",
    "data-name": "Line 1085",
    className: "cls-2",
    x2: 4.101,
    transform: "translate(170.571 106.031)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1086",
    "data-name": "Line 1086",
    className: "cls-2",
    x2: 2.386,
    transform: "translate(170.571 108.219)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1087",
    "data-name": "Line 1087",
    className: "cls-2",
    x2: 5.12,
    transform: "translate(170.571 111.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7046",
    "data-name": "Path 7046",
    className: "cls-1",
    d: "M21.942,22V34.1",
    transform: "translate(145.772 79.858)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1779",
    "data-name": "Ellipse 1779",
    className: "cls-3",
    cx: 2.232,
    cy: 2.232,
    r: 2.232,
    transform: "translate(165.393 115.875)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermostat);
export default __webpack_public_path__ + "static/media/thermostat.244469cc59df332239bd02fd04b18762.svg";
export { ForwardRef as ReactComponent };